import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "like.icon",
  "use": "like.icon-usage",
  "viewBox": "-923.941 -11145.817 52.311 48.381",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-923.941 -11145.817 52.311 48.381\" id=\"like.icon\"><path data-name=\"thumbs up\" d=\"M220.626,225.9H210.09a3.98,3.98,0,0,1-4.01-4.01V199.414a4.244,4.244,0,0,1,.466-1.865l.28-.559L216.9,179.552a3.994,3.994,0,0,1,5.5-1.492,3.859,3.859,0,0,1,1.865,2.331,3.089,3.089,0,0,1,0,2.238v.093c0,.093-.093.187-.093.28l-4.01,12.4H238.9a3.98,3.98,0,0,1,4.01,4.01,4.086,4.086,0,0,1-3.077,3.916h.466a4.01,4.01,0,1,1,0,8.019h-.466a4.016,4.016,0,0,1-.932,7.926h-1.585a3.351,3.351,0,0,1,2.331,4.1,3.3,3.3,0,0,1-3.17,2.424H220.626Zm-24.617,0a3.98,3.98,0,0,1-4.01-4.01V199.414a3.98,3.98,0,0,1,4.01-4.01h4.01a3.98,3.98,0,0,1,4.01,4.01v22.472a3.98,3.98,0,0,1-4.01,4.01Z\" transform=\"translate(-1115.941 -11323.332)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/like.icon.svg
// module id = dYG+
// module chunks = 13